const SupportRequestDetails = () => {
  return (
    <>
      <div className="container">
        <div className="row">
          <div>
            <h2 className="fs-2">Support Request</h2>
          </div>
          <div className="col-12 col-md-6 shadow border rounded p-4 m-3">
            <div className="border-bottom py-2">
              <p>Request Date</p>
              <p>November 22, 2022, 1:07 PM</p>
            </div>
            <div className="border-bottom py-2">
              <p>Request Type</p>
              <p>Insurance Asstance Coverage</p>
            </div>
            <div className="border-bottom py-2">
              <p>Details</p>
              <p>Insurance Asstance Coverage</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6 shadow border rounded py-2 px-4 m-3">
            <h2 className="fs-4 m-0">Activity</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6 shadow border rounded p-4 m-3">
            <div className="d-flex justify-content-between border-bottom py-1">
              <div className="d-flex align-items-center">
                <img style={{ width: 20, height: 20 }} className="rounded-circle object-fit-cover" src="https://images.pexels.com/photos/5792641/pexels-photo-5792641.jpeg?auto=compress&cs=tinysrgb&w=600" />
                <span className="fs-6 ps-2">Jerry Helfer</span>
              </div>
              <div>
                <span>Dec 1, 2023; 10:30 AM</span>
              </div>
            </div>
            <div className="py-3 px-2">
              <p>agfdshgkjlsd</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SupportRequestDetails;